import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import MDBox from "components/MDBox";
import { useAppContextController } from "context/AppContext";
import Attachments from "layouts/pages/interviews/components/InterviewAttachments/Attachments";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useWatch } from "react-hook-form";
import { useQueryClient } from "react-query";
import { INTERVIEW_ENTITIES } from "utils/constants/entityOptions";

const useStyle = makeStyles({
  editor: {
    height: 150,
  },
  box: {
    overflow: "visible",
    height: 550,
  },
});

const { INTERVIEW_TYPES, STATES, INTERVIEW_STATUS } = INTERVIEW_ENTITIES;

const AttachmentsStep = ({
  currentCustomer,
  clearErrors,
  setValue,
  control,
  getValues,
  errors,
  trigger,
  watch,
}) => {
  const { company, currentLoggedUser } = useAppContextController();
  const queryClient = useQueryClient();
  const classes = useStyle();
  const { enqueueSnackbar } = useSnackbar();
  const [attachmentOpen, setAttachmentOpen] = useState(false);

  const attachments = useWatch({
    control,
    name: "attachments",
  });

  const handleSaveAttachment = (att) => {
    setValue("attachments", att, { shouldDirty: true });
  };

  return (
    <>
      <Grid container item xs={12} rowSpacing={4}>
        <Grid item xs={12}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={12}>
              <MDBox mt={2}>
                <Attachments
                  setCurrentInterview={() => {}}
                  currentInterview={{
                    companySlug: "",
                    eventUrl: "",
                    attachments,
                    _id: "",
                  }}
                  setAttachmentOpen={() => {}}
                  onSaveAttachments={handleSaveAttachment}
                  localOnly
                />
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AttachmentsStep;
